import {InferGetStaticPropsType} from 'next';

import Col from '../features/common/Col';
import {useEnvironment} from '../features/common/EnvironmentProvider';
import {useBreakpoint} from '../features/common/util/useBreakpoint';
import {getCmsEntry} from '../features/strapi';
import {ApiFooterFooter, ApiPrivacyPolicyPrivacyPolicy} from '../features/strapi/generated/contentTypes';
import Footer from '../features/tool/components/Footer';
import {getToolLayout} from '../features/tool/components/Layout';
import Newsletter from '../features/tool/components/Newsletter';
import RichText from '../features/tool/components/RichText';
import {buildStaticPropsResponse} from '../features/tool/util/dataFetch';
import {NextPageWithLayout} from './_app';

const PrivacyPolicyPage: NextPageWithLayout<InferGetStaticPropsType<typeof getStaticProps>> = ({
  privacyPolicy,
  footer,
}) => {
  const environment = useEnvironment();
  const {isMobile} = useBreakpoint('mobile');
  return (
    <>
      <Col className="items-center bg-primary-700 py-24 space-y-4 mobile:py-[10rem]">
        <div className="w-full max-w-limit px-md text-white text-huge font-semibold leading-tight">
          Envirocrops Privacy Policy, Terms & Conditions
        </div>
      </Col>
      <Col className="w-full max-w-limit gap-y-16 my-24 mx-auto px-md mobile:max-w-full leading-snug">
        <RichText content={privacyPolicy.body} />
      </Col>
      {environment && <Newsletter data={environment.newsletter} />}
      <Footer data={footer} />
    </>
  );
};

export const getStaticProps = async () => {
  return buildStaticPropsResponse({
    ...(await getCmsEntry<ApiPrivacyPolicyPrivacyPolicy, 'privacyPolicy'>({
      path: 'privacy-policy',
      rootKey: 'privacyPolicy',
      params: {populate: '*'},
      processDataMap: {body: 'html'},
    })),
    ...(await getCmsEntry<ApiFooterFooter, 'footer'>({path: 'footer'})),
  });
};

export default PrivacyPolicyPage;

PrivacyPolicyPage.getLayout = getToolLayout;

PrivacyPolicyPage.title = 'Privacy Policy';
